import React from 'react';
import { TabLayoutTemplate } from 'themes/layouts';

const TabLayout = function (props) {
    return <TabLayoutTemplate {...props} />;
};

export default TabLayout;
